/** @returns {string} */
export function getWalletConnectProjectId() {
  const id = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;
  return id && String(id).trim() ? String(id).trim() : '';
}

export function isWalletConnectConfigured() {
  return Boolean(getWalletConnectProjectId());
}
